import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Card, Space, Typography, message } from "antd";
import { useEffect, useState } from "react";

import { STORAGE_KEYS } from "shared/constant";
import { deleteCookie, getCookie, setCookie } from "shared/method";
import CONFIG from "./config";
import { COOL_DOWN_TIME, MAX_FORGET_LENGTH } from "./define";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

function Login(props) {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState(1);

  const { getFieldDecorator, validateFields, getFieldsError, getFieldValue } = props.form;
  const { sendSmsVerifyCode, logIn, verifyPhone } = props;
  const account = getFieldValue("account");
  const isDisabledLoginBtn = getCookie(STORAGE_KEYS.FORGET_COUNT) === getFieldValue("account");

  useEffect(() => {
    localStorage.removeItem(STORAGE_KEYS.OPEN_MODAL);
  }, []);

  const handleLogin = async (values) => {
    const { success, data, expireTime } = await logIn(values);
    if (success) {
      deleteCookie(STORAGE_KEYS.FORGET_COUNT);
      setPhoneNumber(data.phone);
      await sendSms(data.phone);
      setStep(2);
    } else {
      if (expireTime) setCookie({ key: STORAGE_KEYS.FORGET_COUNT, value: values.account, expireTime });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const values = await validateFields();
      if (step === 1) await handleLogin(values);
      else await verifySms(values);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const sendSms = async (phone = phoneNumber) => {
    try {
      const { success, data } = await sendSmsVerifyCode({
        phoneNumber: phone
      });
      if (success) {
      } else {
        message.error(data);
      }
    } catch (err) {}
  };

  const verifySms = async ({ verifyCode }) => {
    if (!verifyCode || !phoneNumber) return;
    const { success } = await verifyPhone({
      phoneNumber,
      verifyCode
    });
    if (success) {
      message.success("驗證成功");
      window.location.href = "/net-zero/home";
    } else {
      message.error("驗證失敗");
    }
  };

  const isSubmitCode = step === 2;
  const isLogin = step > 1;
  const form = CONFIG.getForm({
    loading,
    isLogin,
    isSubmitCode
  });

  return (
    <Card className="login-wrapper" bordered={false}>
      <Space direction="vertical">
        <img className="logo" src="/logo.png" alt="logo" />
        <Form onSubmit={handleSubmit} id="LoginForm">
          {form.map(({ key, rules, child }) => (
            <Form.Item key={key}>{getFieldDecorator(key, { initialValue: "", rules })(child)}</Form.Item>
          ))}

          {/* <div className="forget-block">
              <a href="/forget">忘記密碼？</a>
            </div> */}

          <Button
            loading={loading}
            type="primary"
            block
            htmlType="submit"
            disabled={isDisabledLoginBtn || hasErrors(getFieldsError())}
          >
            {isLogin ? "驗證" : "登入"}
          </Button>
          <Typography.Text type="danger">
            {account && isDisabledLoginBtn
              ? `錯誤超過${MAX_FORGET_LENGTH}次，請等待${COOL_DOWN_TIME}分鐘後再進行登入`
              : ""}
          </Typography.Text>
        </Form>
      </Space>
    </Card>
  );
}
export default Login;
